import { axios } from '@/utils/request'

/**
 * 学生全部课程列表
 */
export function getMineStudent(param) {
  return axios({
    url: "/sys/user/list",
    method: "get",
    params: param
  });
}

export function addUser(params){
  return axios({
    method: 'post',
    url: '/sys/user/add',
    data: params
  })
}

export function editUser(params){
  return axios({
    method: 'put',
    url: '/sys/user/edit',
    data: params
  })
}

export function forzenUser({ ids, status }) {
  return axios({
    method: 'put',
    url: '/sys/user/frozenBatch',
    data: { ids, status }
  })
}

export function deleteUser(id) {
  return axios({
    method: 'delete',
    url: '/sys/user/delete',
    params: { id: id }
  })
}

export function changePassword(params) {
  return axios({
    url: '/sys/user/changePassword',
    method: 'put',
    data: params
  })
}

export function duplicateCheck(params){
  return axios({
    url: '/sys/duplicate/check',
    params: params
  })
}